<template>
  <div>
    <c-row>
      <c-col col="12">
        <c-card>
          <loader v-show="loading" />
          <c-card-header>
            <strong>Debt</strong>
            <div class="card-header-actions">
              <CInput
                @keyup="doSearch"
                type="text"
                placeholder="Ketikan sesuatu kemudian tekan enter"
                v-model="q"
                style="width: 400px"
                ref="search"
              ></CInput>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Faktur</th>
                  <th>Supplier</th>
                  <th>Total Sisa</th>
                  <th>Jatuh Tempo</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data" :key="k">
                  <td class="center">
                    <table-number
                      :size="dataSize"
                      :page="currentPage"
                      :index="k"
                    />
                  </td>
                  <td>{{ d.faktur }}</td>
                  <td>{{ d.name }}</td>
                  <td align="right">{{ d.total | thousandSeparator }}</td>
                  <td align="right">{{ d.period | dateFormat }}</td>
                  <td align="center">
                    <label class="label bg-warning" v-if="!d.detail_id"
                      >Belum Bayar</label
                    >
                    <label class="label bg-success" v-if="d.detail_id"
                      >Lunas</label
                    >
                    <label class="label bg-danger" v-if="d.out_of_date"
                      >Melebihi Jatuh Tempo</label
                    >
                  </td>
                  <td align="center">
                    <i-button
                      icon="cil-money"
                      color="info"
                      tooltip="Bayar"
                      @action="doPayment(d.id)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <CPagination
              align="end"
              :active-page.sync="currentPage"
              :pages="Math.ceil(total / dataSize)"
              responsive
            />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import IButton from '../../components/IButton.vue';
import Loader from '../../components/Loader.vue';
import TableNumber from "../../components/TableNumber";
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";

export default {
  name: "CardList",
  components: {
    TableNumber,
    IButton,
    Loader
  },
  data () {
    return {
      loading: true,
      currentPage: 1,
      total: 1,
      data: [],
      q: "",
      dataUrl: "/api/v1/debt",
      dataSize: 10
    };
  },
  created () {
    const query = this.$route.query;
    if (query.q) {
      this.loadData(1, query.q);
      this.q = query.q;
      return;
    }
    this.loadData(1, "");
  },
  methods: {
    loadData (page, q) {
      this.loading = true
      this.currentPage = page;
      HTTPAUTH.get(
        this.dataUrl + `?q=${q}&page=${page}&size=${this.dataSize}`
      ).then(res => {
        const paginate = res.data.paginate;
        this.total = paginate.total;
        this.data = res.data.data;
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    doSearch (e) {
      if (e.keyCode === 13) {
        this.loadData(1, this.q);
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    doPayment (id) {
      this.$router.push('/j/debt/' + id)
    }
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(pageNext, q);
    }
  }
};
</script>